
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form6";
const form6State = namespace("Form6");

import Form6ProcessHeader from "@/components/process/Form6/components/Form6ProcessHeader.vue";
import Form6 from "@/components/process/Form6/components/pdf/Form6.vue"

import { form6StatusInfoType } from '@/types/Information/Form6';

@Component({
    components:{
        Form6ProcessHeader,
        Form6
    }
})
export default class PreviewForm6 extends Vue {

    @form6State.State
    public currentNoticeOfSettlementOrAbandonmentId: string;

    stepsCompleted = {} as form6StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form6"}); 
    }
}
